import LoadingStatus from 'enums/loadingStatus';
import { LocationType } from 'features/searchResultsFacets';

const searchCommandElement = document.querySelector("[data-component='search-command-data']");
const searchCommandData = JSON.parse(searchCommandElement.innerHTML);

const isSearchWithinMapOn = () => searchCommandData.Location.LocationType === LocationType.RectangularArea.name;

export default {
    isSearchWithinMapReady: false,
    mapLibraryStatus: LoadingStatus.Idle.toString(),
    isSearchWithinMap: isSearchWithinMapOn(),
    selectedMarker: null,
    sitePlans: [],
};